import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {WinPresentationView} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {Timer} from '@fantasmagames/core/src/update/Timer';

export class WinPresentationSkippedState extends ModuleState<WinPresentationView, WinPresentationModule> {
	protected static FINAL_SKIPPED_SHOWING_TIMER: number = 1000;

	protected _skippedTimer: Timer;

	public onEnterState(): void {
		this.view.killCurrentWinPresentation();

		this._skippedTimer = new Timer(() => {
			this.view.forceKillWinNumbers();
			this._skippedTimer = null;
			this.module.gotoState(WinPresentationModule.BASIC);
		}, WinPresentationSkippedState.FINAL_SKIPPED_SHOWING_TIMER, true);
		this.module.updateManager.add(this._skippedTimer);
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(SpinButtonEvents.QUICKSTOP_PRESSED, this.onQuickstopPressed);
	}

	protected onQuickstopPressed(): void {
		this._skippedTimer.stopWithCallback();
		this._skippedTimer = null;
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationSkippedState.ts